import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "flex flex-col space-y-4" };
const _hoisted_2 = { class: "w-10 bg-warning-100 border-8 border-solid border-warning-50 h-10 rounded-3xl flex flex-col justify-center items-center" };
const _hoisted_3 = { class: "py-2" };
const _hoisted_4 = { class: "py-2" };
const _hoisted_5 = { class: "flex items-end justify-end space-x-3" };
import { AlertCircleIcon } from '@gohighlevel/ghl-icons/24/outline';
import { UIButton, UICard, UITextMdMedium, UITextSmNormal, } from '@gohighlevel/ghl-ui';
export default /*#__PURE__*/ _defineComponent({
    __name: 'ConfirmationModal',
    props: {
        showModal: {
            type: Boolean,
            require: true,
        },
    },
    emits: ['discard', 'continue-editing'],
    setup(__props, { emit: emits }) {
        function continueEditing() {
            emits('continue-editing');
        }
        function discard() {
            emits('discard');
        }
        return (_ctx, _cache) => {
            return _withDirectives((_openBlock(), _createBlock(_unref(UICard), {
                class: "max-w-sm absolute z-40",
                style: { "top": "30%", "left": "45%" }
            }, {
                default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_1, [
                        _createElementVNode("div", null, [
                            _createElementVNode("div", _hoisted_2, [
                                _createVNode(_unref(AlertCircleIcon), { class: "w-8 h-8 text-warning-400" })
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_3, [
                            _createVNode(_unref(UITextMdMedium), null, {
                                default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t('common.discardHeading')), 1 /* TEXT */)
                                ]),
                                _: 1 /* STABLE */
                            })
                        ]),
                        _createElementVNode("div", _hoisted_4, [
                            _createVNode(_unref(UITextSmNormal), null, {
                                default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t('common.discardSubHeading')), 1 /* TEXT */)
                                ]),
                                _: 1 /* STABLE */
                            })
                        ]),
                        _createElementVNode("div", _hoisted_5, [
                            _createVNode(_unref(UIButton), {
                                id: "ghl-image-editor-confirm-cancel",
                                onClick: continueEditing
                            }, {
                                default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t('common.continue')), 1 /* TEXT */)
                                ]),
                                _: 1 /* STABLE */
                            }),
                            _createVNode(_unref(UIButton), {
                                type: "error",
                                id: "ghl-image-editor-confirm-discard",
                                onClick: discard
                            }, {
                                default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t('common.discard')), 1 /* TEXT */)
                                ]),
                                _: 1 /* STABLE */
                            })
                        ])
                    ])
                ]),
                _: 1 /* STABLE */
            }, 512 /* NEED_PATCH */)), [
                [_vShow, __props.showModal]
            ]);
        };
    }
});
